export default {
  'APP_SHIPMENT_UPDATE': 'APP_SHIPMENT_UPDATE',
  'APP_SHIPMENT_ADMIN': 'APP_SHIPMENT_ADMIN',
}